// Region names arrive as a full path ("Warszawa, Wola, Mirów") - only the last part names the region.
export const getRegionShortLabel = (shortName: string): string => shortName.split(", ").pop() ?? shortName;
// Region names arrive as a full path ("Warszawa, Wola, Mirów") - only the last part names the region.
export const getRegionShortLabel = (shortName: string): string => shortName.split(", ").pop() ?? shortName;
